import { GeolocationCookieService as o } from "./main21.js";
import { CookieModule as e } from "@packages/common";
const l = {
  name: "GeolocationCookieModule",
  modules: [e],
  providers: [o]
};
export {
  l as GeolocationCookieModule
};
